"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddFilterButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      marginTop: "0.5rem"
    },
    addButtonWrapper: {
      display: "grid",
      placeItems: "center"
    }
  };
});
var AddFilterButton = function AddFilterButton(_ref) {
  var isDisabled = _ref.isDisabled,
    handleClick = _ref.handleClick;
  var classes = useStyle();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.addButtonWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "secondary",
    disabled: isDisabled,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    fontSize: "large"
  }, "add"))));
};
exports.AddFilterButton = AddFilterButton;